import React from 'react';

export default function MemorialMessage({ message, metadata }) {
  const suffix = metadata.zlSuffix[parseInt(message.crfd1_suffix, 10) - 648970000];
  const cause = metadata.zlCause[parseInt(message.crfd1_cause, 10) - 648970000];
  const day = metadata.day[parseInt(message.crfd1_day, 10) - 648970000];
  const month = metadata.month[parseInt(message.crfd1_month, 10) - 648970000];

  return (
    <div className="memorial-message">
      הלימוד היום לעילוי נשמת
      <br />
      <div className="memorial-message-name-block">
        <b className="memorial-message-name">
          {message.crfd1_name} {suffix}
        </b>
      </div>
      <div className="memorial-message-details">
        {message.crfd1_boger ? (
          <>
            בוגר הישיבה
            <br />
            ש
          </>
        ) : null}
        {cause}
        {message.crfd1_gender === false ? 'ה' : ''} ב{day} {month} {message.crfd1_year}
        <br />
        {message.crfd1_note}
      </div>
      ת.נ.צ.ב.ה.
    </div>
  );
}
